import { Create, SaveButton, SimpleForm, Toolbar } from "react-admin";
import { Paper, Typography } from "@mui/material";

const VestingSaveButton = (props) => {
  return (
    <SaveButton
      {...props}
      type="button"
      alwaysEnable
      label={"Executar Vesting"}
    />
  );
};

const VestingToolbar = (props) => (
  <Toolbar {...props}>
    <VestingSaveButton />
  </Toolbar>
);

const VestingSection = () => (
  <Create redirect="list">
    <SimpleForm toolbar={<VestingToolbar />}>
      <Paper sx={{ width: "97%", padding: 2, margin: 2 }}>
        <Typography align="center" variant="h5" gutterBottom>
          Executar Vesting (Pré-Sale)
        </Typography>

        <Typography variant="body1" sx={{ mt: 2 }}>
          Clique no botão abaixo para processar o vesting em todos os usuários
          que possuem saldo de pré-venda.
        </Typography>
      </Paper>
    </SimpleForm>
  </Create>
);

export default VestingSection;
